const ProjectTypes = {
  CLASSIC: 'classic',
  SWIFT: 'swift',
  PRO: 'pro',
  OCCASION_BOOK: 'occasion book',
};

module.exports = ProjectTypes;
